// Regroupe les users par fratrie (ou seul) et calcule le solde restant du groupe,
// exactement comme la colonne "Montant restant" du tableau.
export const getRemainingGroups = (users = []) => {
  const byFratrie = new Map();
  const groups = [];

  users.forEach((u) => {
    if (!u.id_fraternity) {
      groups.push({ key: `u-${u.id_user_season}`, members: [u], remaining: u.remaining_amount });
      return;
    }
    let group = byFratrie.get(u.id_fraternity);
    if (!group) {
      group = {
        key: `f-${u.id_fraternity}`,
        members: [],
        remaining: -(Number(u.discount_fratrie) || 0), // remise fratrie retirée une seule fois
      };
      byFratrie.set(u.id_fraternity, group);
      groups.push(group);
    }
    group.members.push(u);
    group.remaining += u.remaining_amount;
  });

  return groups;
};